import PubSub from "underpub-js";

var ButtonTertiary = function(options) {

	this.options = {
		$el: false,
		baseClass: 'atom-ButtonTertiary',
	};

	$.extend(true, this.options, options);

};

ButtonTertiary.prototype.init = function() {

	var self = this;

};

export default ButtonTertiary;
